import React from "react";

export function SelectAmount({amounts, onChange}) {

    return <section>
        <label className="select">
            <select name="gender" id="amount"
                    required="required"
                    onChange={(event) => onChange && onChange(event.target.value)}
            >
                <option value="" disabled selected>Iznos dopune</option>
                {amounts && amounts.map(item => <option>{item}</option>)}
            </select>
            <i></i>
        </label>
    </section>

}